export function isPgaSectionWorkdayDepartment(name: string): boolean {
  return name.trim().toLowerCase().endsWith(" section");
}
